import { mutationNames } from '@/store/storeKeysettings'
import {
  mapGetters
}
from 'vuex'
import {
    Get
} from '@/modules/wrapper/apiWrapper'
import { ConstPaths }from '@/config/pathConfig'
import appconfig from '@/store/modules/appconfig'

const state = {
  RssFeedInfo: {
    'Id': '',
    'Module_Id': 0,
    'PageTitle': '',
    'RSSFeedURL': '',
    'RowCreated': null,
    'RowUpdated': null,
    'SubscriptionModule_Id': 0
  },
  RssFeedData: null
}

const mutations = {
  [mutationNames.SET_RSSFEEDDATA](state, feedInfo) {
    state.RssFeedInfo = feedInfo
  },
  [mutationNames.UPDATE_RSSFEEDDATA](state, feedInfo) {
    state.RssFeedInfo = feedInfo
  },
  [mutationNames.SET_RSSFEEDLIST](state, feeddata) {
    state.RssFeedData = feeddata
  }
}

const actions = {
  // initapi: async ({commit}) => {
  //   let feedurl =  await Get (appconfig.state.AppConfig.Urls.WebAPIURL + '/api/ModulesRSSFeed/?feedUrl=http://www.tagesschau.de/xml/rss2')
  //   commit(mutationNames.SET_RSSFEEDDATA,feedurl.Items)
  // }
}

const getters = {
  RssFeedInfo: state => {
    return state.RssFeedInfo
  },
  RssFeedData: state => {
    return state.RssFeedData
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/rssfeed.js